
import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";
export class ProjectTaskManagementApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'project-task-management'
    }




    /**
     *

     * 项目信息
     * @param province
     * projectName：项目名称
     * 开始时间：startTime
     * 结束时间：endTIme
     * 完成率：finishingRate
     */
    public itemInformation(province){
        return this.send({province:province},"itemInformation",Methods.GET)
    }


    /**
     * 物联网建设内容
     * @param province
     *  type：类型
     * designQuantity：设计数量
     * accomplish：完成数量
     * OutstandingQuantity：未完成数量
     * startTime ：开始时间
     * endTIme：结束时间
     *  tokens :附件信息
     */
    public thingsConstruction(projectIds){
        return this.send(projectIds,"thingsConstruction",Methods.POST)
    }

    /**
     * 标段信息
     * @param province
     */
    public sectionInformation(projectIds){
        return this.send(projectIds,"sectionInformation",Methods.POST)
    }

    /**
     * 数据异常报警
     * @param province
     * 对照 数据中心 equipment_warning_info表中字段
     */
    public dataExceptionAlarm(projectIds){
        return this.send(projectIds,"dataExceptionAlarm",Methods.POST)
    }

    /**
     * 物联网数据状态 （饼状图）
     * earlyWarning  正常设备
     * noEarlyWarning 异常设备
     * normalRate 正常率
     * noNormalRate 故障率
     * @param province
     */
    public iotDataState(projectIds){
        return this.send(projectIds,"iotDataState",Methods.POST)
    }



    /**
     * 物联网数据状体
     * DeviceName    设备名称
     * Start 状态
     * failureRate  预警次数
     * DataGatherDeadline  采集更新截止时间
     * @param province
     */
    public iotDataForm(param){
        return this.send({section:param.section,projectId:param.projectId},"iotDataForm",Methods.GET)
    }
    /**
     * 项目实施情况统计
     * @param province
     *
     //三方数据对接情况
     *          docked //已对接
     *          toBeDocked //待对接
     *          dockedProportion  /已对接占比
     *          toBeDockedProportion //待对接占比
     *         //物联网实施情况
     *          implemented ;//已实施
     *          tyoBeImplemented ;//待实施
     *          implementedProportion ;//已实施占比
     *          tyoBeImplementedProportion ;//待实施占比
     *         //物联网设备状体
     *          abnormalQuantity ;//异常数量
     *          normalQuantity ;//正常数量
     *          abnormalQuantityProportion;//异常数量占比
     *          normalQuantityProportion ;//正常数量占比
     */
    public projectImplementationStatistics(projectId){
        return this.send({projectId:projectId},"projectImplementationStatistics",Methods.GET)
    }


    /**
     * 第三方数据对接情况
     * platformName    平台名称（单位名称）
     * type 类型
     * BusinessType  对接形式
     * accomplish  完成数量
     * designQuantity 总数
     *   outstandingQuantity  未完成数量
     * @param province
     */
    public homePageSignage(projectIds){
        return this.send(projectIds,"homePageSignage",Methods.POST)
    }
}
